<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>

    export default {
        name: "machining",
    }
</script>

<style lang="scss" scoped>

</style>